import { render, staticRenderFns } from "./InputButtonId.vue?vue&type=template&id=006f8d6e&"
import script from "./InputButtonId.vue?vue&type=script&lang=js&"
export * from "./InputButtonId.vue?vue&type=script&lang=js&"
import style0 from "./InputButtonId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports